<template>
<v-container>
  <v-layout>
    <v-flex xs12>
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 >
          <v-card class="px-5 py-4">
            <form @submit.prevent="openReAuth('saveEmail', 'Enter your current password to change your email address.')">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Your email</span>
                </v-flex>
              </v-layout>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                     <v-text-field
                      name="email"
                      label="Mail"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                    <v-btn block depressed color="secondary" type="submit" :disabled="loading" :loading="loading">
                      Save Email
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                </form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <v-card class="px-5 py-4">
            <form @submit.prevent="openReAuth('savePassword', 'Enter your current password to save your new password.')">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Change your password</span>
                </v-flex>
              </v-layout>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                      <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      type="password"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                    <v-btn block depressed color="secondary" type="submit" :disabled="loading" :loading="loading">
                      Save Password
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                </form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <v-card class="px-5 py-4">
            <form @submit.prevent="openReAuth('deleteAccount', 'This is final and we will remove all documents from your app. Enter your password to continue.')">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Delete account</span>
                </v-flex>
              </v-layout>
              <v-layout align-end row fill-height wrap>
                <v-flex xs12 md8>
                  <p>Once you delete your account, there is no going back. Please be certain.</p>
                </v-flex>
                <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                  <v-btn block depressed color="warning" type="submit" :disabled="loading" :loading="loading">
                    Delete account
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <reauthenticate
    @closeReAuth='closeReAuth'
    :showReAuthDialog='showReAuthDialog'
    @deleteAccount='onDeleteAccount'
    @saveEmail='onSaveEmail'
    @savePassword='onSavePassword'
    :callback='callback'
    :dialogMessage='dialogMessage'></reauthenticate>
  </v-layout>
</v-container>
</template>

<script>
import firebase from 'firebase'
import Reauthenticate from '@/components/Shared/Reauthenticate'
export default {
  components: {
    Reauthenticate
  },
  data () {
    return {
      user: this.$store.getters.user,
      complete: false,
      email: this.$store.getters.user.email,
      password: '',
      dialogMessage: '',
      callback: '',
      showReAuthDialog: false

    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onSaveEmail () {
      // Vuex
      if (this.email === '') {
        this.$store.dispatch('setError', { message: 'Please enter an email address' })
      }
      this.$store.dispatch('updateEmail', this.email)
    },
    onSavePassword () {
      // Vuex
      if (this.password === '') {
        this.$store.dispatch('setError', { message: 'Please enter a 6 digit password' })
      }
      this.$store.dispatch('updatePassword', this.password)
    },
    openReAuth (callback, dialogMessage) {
      this.callback = callback
      this.dialogMessage = dialogMessage
      this.showReAuthDialog = true
    },
    closeReAuth () {
      this.showReAuthDialog = false
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    onDeleteAccount () {
      // quick check again to ensure that delete is typed
      const fbupdates = {}
      const userId = this.user.id
      const fbuser = firebase.auth().currentUser
      this.$store.commit('setLoading', true)
      fbupdates[`users/${userId}`] = null
      fbupdates[`documents/${userId}`] = null
      firebase.database().ref().update(fbupdates).then(() => {
        fbuser.delete()
      }).then(() => {
        this.$store.commit('setError', false)
        this.$store.commit('setLoading', false)
        this.showDialog = false
        this.$store.dispatch('logout')
      }).catch(error => {
        this.$store.commit('setError', error.message)
        this.$store.commit('setLoading', false)
      })

      // firebase.database().ref('clients').child(groupId).equalTo(key).once('value', snapshot => {
      //     snapshot.forEach(child => updates[child.key] = null);
      //     return updates
      // })
      // ref.update(updates);
    }
  }
}
</script>
